'use client';

import { alpha, Box, Skeleton } from '@mui/material';

interface ProfitLossSkeletonProps {
  hideHeader?: boolean;
}

export const ProfitLossSkeleton = ({ hideHeader = false }: ProfitLossSkeletonProps) => {
  return (
    <Box sx={{ p: 0.5 }}>
      {/* Header Skeleton */}
      {!hideHeader && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Skeleton
            variant="text"
            width={100}
            height={20}
            sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), borderRadius: 1 }}
          />
          <Skeleton
            variant="text"
            width={120}
            height={24}
            sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), borderRadius: 1 }}
          />
        </Box>
      )}

      {/* Stats Skeleton */}
      <Box sx={{ mb: 2 }}>
        <Skeleton
          variant="rectangular"
          width={150}
          height={32}
          sx={{
            bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1),
            borderRadius: 1,
            mb: 0.5,
          }}
        />
        <Skeleton
          variant="text"
          width={80}
          height={16}
          sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), borderRadius: 1 }}
        />
      </Box>

      {/* Chart Skeleton */}
      <Box
        sx={{
          height: 140,
          width: '100%',
          bgcolor: (theme) => alpha(theme.palette.text.primary, 0.05),
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            width: '90%',
            height: '70%',
            bgcolor: (theme) => alpha(theme.palette.text.primary, 0.05),
            borderRadius: 1,
          }}
        />
      </Box>
    </Box>
  );
};
